import axios from 'axios'

axios.defaults.withCredentials = true

const capicoHosts = JSON.parse(process.env.VUE_APP_HOSTS)
const capicoHost = capicoHosts[Math.floor(Math.random() * capicoHosts.length)]
// console.log('capico host:', capicoHost)

export default {
  ge: axios.create({
    baseURL: capicoHost,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json'
    }
  }),
  sg: axios.create({
    baseURL: capicoHost.replace('https://capico', 'https://sg.capico').replace('https://titan', 'https://sgtitan'),
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json'
    }
  }),
  get: axios.create({
    baseURL: capicoHost.replace('https://capico', 'https://get.capico').replace('https://titan', 'https://gettitan'),
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json'
    }
  }),
  hk: axios.create({
    baseURL: capicoHost.replace('https://', 'https://hk.'),
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
